import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const MultipleImageUpload = ({ onImageChange, value }) => {
  const [images, setImages] = useState(value || []);

  useEffect(() => {
    if (value) {
      setImages(
        value.map((img) => ({
          file: img.file || null,
          url: img.url || null,
          description: img.description || "",
        }))
      );
    }
  }, [value]);

  const handleImageChange = (event) => {
    const files = event.target.files;
    const newImages = [...images];

    for (let i = 0; i < files.length; i++) {
      if (newImages.length < 6) {
        newImages.push({
          file: files[i],
          url: URL.createObjectURL(files[i]),
          description: "",
        });
      }
    }

    setImages(newImages);
    onImageChange(newImages);
  };

  const handleRemoveImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
    onImageChange(newImages);
  };

  const handleDescriptionChange = (event, index) => {
    const newImages = [...images];
    newImages[index].description = event.target.value;
    setImages(newImages);
    onImageChange(newImages);
  };

  const thumbnailStyle = {
    maxWidth: "100%",
    maxHeight: "100px",
    width: "auto",
    height: "auto",
    display: "block",
    marginBottom: "4px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };

  const imageContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Align items to the left
    marginBottom: "16px",
    width: "100%", // Take full width of the line
  };

  const removeButtonStyle = {
    marginLeft: "8px",
  };

  return (
    <Grid container spacing={2} alignItems="flex-start">
      {" "}
      {/* Align items at the start */}
      <Grid item xs={12}>
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageChange}
          style={{ display: "block", marginBottom: "16px" }}
          id="multiple-image-upload"
        />
      </Grid>
      {images.map((imageItem, index) => (
        <Grid item xs={12} key={index} sx={imageContainerStyle}>
          <Box display="flex" alignItems="center" marginBottom="8px">
            {imageItem.url && (
              <img
                src={imageItem.url}
                alt={`Uploaded ${index + 1}`}
                style={thumbnailStyle}
              />
            )}
            <IconButton
              onClick={() => handleRemoveImage(index)}
              color="secondary"
              size="small"
              sx={removeButtonStyle}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
          <TextField
            label={`Description for Image ${index + 1}`}
            fullWidth
            variant="outlined"
            size="small"
            value={imageItem.description}
            onChange={(e) => handleDescriptionChange(e, index)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MultipleImageUpload;
